/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Variant_Stock_NoneInputs */

const vi_shop_variant_stock_none = /** @type {(inputs: Shop_Variant_Stock_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hết`)
};

/**

* @param {Shop_Variant_Stock_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_stock_none = /** @type {((inputs?: Shop_Variant_Stock_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_Stock_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_stock_none(inputs)
});